export default server => ({
    async profile(id) {
        let {data} = await server.get(`users/${id}`);
        return data;
    },
    async saveProfile(id, data) {
        let {data: {user}} = await server.patch(`users/${id}`, data);
        return user;
    },


    /* async check() {
         let {data} = await server.get('auth/check', {
             errorSuppression: {},
             silence401: true
         });
         return data;
     },*/
    /*    async logout() {
            let {data} = await server.get('auth/logout.php', {
                errorSuppression: {text: 'при выходе с сайта'}
            });
            return data;
        }*/
});